/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react";
import { Route, Switch } from "react-router-dom";
import { Footer } from "../Footer/footer";
import { LineupTab } from "../Lineup";
import { Videos } from "../Videos";
import { MainPage } from "../MainPage/main-page";
import { Navbar } from "../Navbar";
import "./styles.scss";
import { Teams } from "../Teams";
import { People } from "../People";
import { NotFound } from "../NotFound/not-found";
import { Merch } from "../Merch/merch";
import { Sponsors } from "../Sponsors/sponsors";

export const App = (): JSX.Element => (
  <>
    <Navbar />
    <Switch>
      <Route path="/" exact component={MainPage} />
      <Route path="/rsvp" exact component={MainPage} />
      <Route path="/lineup" exact component={LineupTab} />
      <Route path="/videos" exact component={Videos} />
      <Route path="/teams" exact component={Teams} />
      <Route path="/people" component={People} />
   <Route path="/merch" component={Merch} />
   <Route path="/sponsors" component={Sponsors} />
      <Route component={NotFound} />
    </Switch>
    <Footer />
  </>
);
